import styled from "styled-components";
import React, { ReactNode } from 'react';

const Wrapper = styled.div`
    position: relative;
`;

const Container = styled.div`
    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    & * {
        flex: 0 0;
    }
`;

const Background = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: linear-gradient(#90909000 0%, #ccccccFF 50%, #90909000 100%);
    opacity: .2;
    z-index: 1;
`;

const TitleContainer = (props: {children: ReactNode}) => {
    return <Wrapper>
        <Background/>
        <Container>{props.children}</Container>
    </Wrapper>
}
export default TitleContainer;